/*global FB:true,fbq,_fbq*/

import config from 'config'
import loadScript from 'helpers/loadScript'

const facebookSdk = function() {
	return new Promise(function(resolve, reject) {
		let loadCount = 0

		window.fbAsyncInit = function() {
			FB.init({appId: '265911660250390', status: true, xfbml: false})
		}

		function checkLoaded() {
			if (loadCount < 10) {
				if (window.FB) {
					resolve(true)
				} else {
					loadCount++
					setTimeout(checkLoaded, 1000)
				}
			} else {
				reject('couldnt load facebook library')
			}
		}

		function loadPlatform() {
			(function(d, s, id) {
				var js, fjs = d.getElementsByTagName(s)[0]
				if (d.getElementById(id)) {
					return
				}
				js = d.createElement(s); js.id = id;js.async = true
				js.src = 'https://connect.facebook.net/en_US/all.js'
				fjs.parentNode.insertBefore(js, fjs)
			}(document, 'script', 'facebook-jssdk'))
			checkLoaded()
		}

		loadPlatform()
		checkLoaded()
	})
}

const googleSdk = function() {
	return new Promise(function(resolve, reject) {
		let state = 0
		let loadCount = 0

		function checkLoaded() {
			if (loadCount < 1000) {
				if (window.gapi) {
					if (state === 1) {
						client()
					} else if (window.gapi.auth) {
						resolve(true)
					} else {
						loadCount++
						setTimeout(checkLoaded, 1000)
					}
				} else {
					loadCount++
					setTimeout(checkLoaded, 1000)
				}
			} else {
				reject('couldnt load google library')
			}
		}

		function loadPlatform() {
			(function() {
				var po = document.createElement('script'); po.type = 'text/javascript';po.async = true
				po.src = 'https://apis.google.com/js/platform.js'
				var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(po, s)
			})()
			state = 1
			checkLoaded()
		}

		function client() {
			(function() {
				var po = document.createElement('script'); po.type = 'text/javascript';po.async = true
				po.src = 'https://apis.google.com/js/client.js'
				var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(po, s)
			})()
			state = 2
			checkLoaded()
		}

		loadPlatform()
		checkLoaded()
	})
}

const gtmSdk = function() {
	return new Promise(function(resolve) {
		var gtmCode = config.log.gtm;
		(function(w, d, s, l, i) {
			w[l]=w[l]||[];w[l].push({'gtm.start':
		new Date().getTime(), event: 'gtm.js'});var f=d.getElementsByTagName(s)[0],
				j=d.createElement(s), dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
		'//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j, f)
		})(window, document, 'script', 'dataLayer', gtmCode)
		window.dataLayer = window.dataLayer || []

		resolve()
	})
}


const facebookPixelSdk = function() {
	return new Promise(function(resolve) {
		function loadFacebookPixel() {
			!function(f, b, e, v, n, t, s) {
				if (f.fbq) return;n=f.fbq=function() {
					n.callMethod?
						n.callMethod.apply(n, arguments):n.queue.push(arguments)
				}
				if (!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0'
				n.queue=[];t=b.createElement(e);t.async=!0
				t.src=v;s=b.getElementsByTagName(e)[0]
				s.parentNode.insertBefore(t, s)
			}(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')

			fbq('init', '950663441624518')
			fbq('track', 'PixelInitialized')
		}
		loadFacebookPixel()

		resolve()
	})
}

const googleApiInitializer = (function() {

	function loadPlatform() {
		return new Promise(function(resolve) {
			function checkLoaded() {
				if (window.gapi) {
					resolve(window.gapi)
				} else {
					setTimeout(checkLoaded, 1000)
				}
			}
			checkLoaded()
		})
	}

	function initializeGoogleApi() {
		return loadPlatform()
	}

	let promise
	return function() {
		if (!promise) {
			promise = initializeGoogleApi()
		}
		return promise
	}
}())


const pixelTracker = (function() {
	function track(event) {
		_fbq('track', event)
	}
	return {
		track,
	}
}())

const gtmPushMetric = function(event_name, payload) {
	window.dataLayer.push({
		event: event_name,
		payload,
	})
}

const OneDrive = loadScript('https://js.live.net/v7.2/OneDrive.js')

const immersiveReader = loadScript('https://contentstorage.onenote.office.net/onenoteltir/immersivereadersdk/immersive-reader-sdk.1.1.0.js')

const awsSdk = async () => loadScript('https://sdk.amazonaws.com/js/aws-sdk-2.639.0.min.js')

const cseLibrary = async () => {
	window.__gcse = window.__gcse || {
		parsetags: 'explicit', // Use 'explicit' to decide when to render it
		defaultToImageSearch: true,
		enableImageSearch: true,
		initializationCallback: () => {},
		searchCallbacks: {
			image: {
				starting: () => {},
				ready: () => {},
				rendered: () => {},
			},
			web: {
				starting: () => {},
				ready: () => {},
				rendered: () => {},
			},
		},
	}
	if (!window.google || !window.google.search) {
		loadScript('https://cse.google.com/cse.js?cx=013765627635899298380:gskfnsfgc8r')
	}
}

export {
	facebookSdk,
	googleSdk,
	gtmSdk,
	facebookPixelSdk,
	pixelTracker,
	OneDrive,
	googleApiInitializer,
	immersiveReader,
	gtmPushMetric,
	awsSdk,
	cseLibrary,
}
